import { render } from "./DialogCloseCreateCycle.vue?vue&type=template&id=054a16df"
import script from "./DialogCloseCreateCycle.vue?vue&type=script&lang=js"
export * from "./DialogCloseCreateCycle.vue?vue&type=script&lang=js"
script.render = render

export default script